<template>
  <div class="modal fade" id="modalChangePaymentMethod" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content modal-subscription">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body pt-2">
          <div class="row">
            <div class="col-12 text-left">
              <h1 class="plan-subheader">Cambiar método de pago</h1>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="row mt-2">
                <div class="col-12">
                  <span class="plan-primary">Tarjeta actual:</span>
                  <span class="ml-1 plan-secondary">{{planDetails.plan_detail.brand}} **** **** **** {{planDetails.plan_detail.last_four}}</span>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <p class="plan-description">Cambiar tu método de pago no afectará tu plan en curso. De no poderse efectuar la transacción el día de corte, te enviaremos un correo para notificarte. Tendrás un periodo de 15 días naturales para poder corregir tu información.</p>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <span class="plan-primary light">Próximo cobro: {{planDetails.plan_detail.next_charge}}</span>
                </div>
              </div>
            </div>

            <div class="col-6 text-left px-5" style="border-left: solid 1px lightgray;">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <input type="text" id="name" class="input-no-label form-control" :class="{'is-invalid': $v.userData.name.$error}" v-model="userData.name" placeholder="Nombre">
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <div class="form-group">
                    <div id="card-payment-method"></div>
                    <div id="card-errors" class="text-danger text-left" style="font-size: 10px" role="alert">{{errorMessage}}</div>
                  </div>
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-12">
                  <button type="button" :disabled="cardErrors" class="btn btn-save form-control text-center text-uppercase" @click="changePaymentMethod()">
                    Cambiar método de pago
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var stripe;
if(process.env.NODE_ENV != "development"){
  stripe = window.Stripe('pk_live_51HRMCLKkIGgB4LQza1KU154xMkB0jqbV96jsMyUoI51HnTtq91ObYI68bz574l7gK2WBnT4Jfhb8IgEOf6DTb1mt00aMFUSCFS');
}else{
  stripe = window.Stripe('pk_test_51HRMCLKkIGgB4LQz3NYkulIMvr0cnqvcimS7GYV8CgXS3bG7iQV5e6UkfJXWN5RyfQfWgAYvsS6Ayl3Z8POAUGA400NITo53lO');
}
const elements = stripe.elements({
  fonts: [
    {
      // integrate your font into stripe
      cssSrc: 'https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap',
    }
  ]
});

import filters from "@/mixins/filters";
import data from "@/mixins/data";
import $ from "jquery";
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators';
import plansService from "@/api/plans";
export default {
  mixins:[data,filters,validationMixin],
  mounted(){
    if(this.card != null){
      this.card.unmount();
    }
    this.card = elements.create('card',{
      style: {
        base:{
          color: '#B3B3B3',
          fontFamily: 'Open Sans',  // set integrated font family
          fontSmoothing: 'antialiased',
          fontSize: '15px',
          '::placeholder': {
            color: '#6c757d'
          }
        }
      }
    });
    this.card.mount('#card-payment-method');
    this.card.addEventListener('change', (event) => {
      if (event.error) {
        this.errorMessage = event.error.message;
      }else{
        this.errorMessage = "";
      }
      if(event.complete == true && event.error == null){
        this.cardErrors = false;
      }else{
        this.cardErrors = true;
      }
    });
  },
  beforeDestroy() {
    if(this.card != null){
      this.card.destroy();
    }
    $(".modal-backdrop").remove();
  },
  data(){
    return{
      card:null,
      errorMessage: "",
      cardErrors:true,
      userData:{
        name:""
      }
    }
  },
  methods:{
    createToken(){
      return new Promise( (resolve,reject) => {
        stripe.createToken(this.card).then(
          result => {
            if(result.error){
              reject(result.error)
            }else{
              resolve(result.token.id)
            }
          }
        ).catch(
          error => {
            reject(error)
          }
        );
      })
    },
    addPaymentMethod(token){
      let formatedToken = {
        token_card : token
      }
      return new Promise((resolve,reject) => {
        plansService.addPaymentMethod(formatedToken).then(
          response =>{
            resolve(response.data.data)
          }
        ).catch(
          error => {
            reject(error)
          }
        );
      });
    },
    changePaymentMethod(){
      this.$v.$touch()
      if (this.$v.userData.$invalid) {
        this.$store.dispatch('showMessage',{
          action:'error',
          message:'Llena todos los campos requeridos'
        });
      }else{
        this.$store.dispatch("showLoader", { show: true });
        this.createToken().then(
          token => {
            this.addPaymentMethod(token).then(
              this.$store.dispatch('client/updatePlanDetails').then(
                () =>{
                  this.$store.dispatch("showLoader", { show: false });
                  $("#modalChangePaymentMethod").modal("hide");
                }
              ).catch(
                ()=>{
                  this.$store.dispatch("showLoader", { show: false });
                }
              )
            ).catch(
              () => {
                this.$store.dispatch("showLoader", { show: false });
              }
            )
          }
        ).catch(
            (error) => {
              let errorCode = error.code || "";
              let errorMsg = error.message || error;
              this.$store.dispatch("showMessage", {
                action: "error",
                message: errorCode+" "+errorMsg,
              });
              this.$store.dispatch("showLoader", { show: false });
            }
          )
      }
    }
  },
  validations: {
    userData:{
      name:{
        required
      }
    }
  }
};
</script>